module.exports = __webpack_public_path__ + "img/amazon.cd84e287.svg";